import React, { useState } from 'react';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import { Controller } from 'react-hook-form';
import { Box, Typography } from '@mui/material';
import { validatePhone } from '../../../helpers/lib';
import styles from './styles';

const errorMessage = 'Номер введен некорректно';

function PhoneField({
  name,
  formFunctions: { register, control, setValue, errors, setError, clearErrors },
}) {
  const [isValid, setIsValid] = useState();
  return (
    <Box sx={styles.phoneWrapper}>
      <Controller
        render={() => (
          <PhoneInput
            inputClass={errors.phone ? 'danger' : ''}
            placeholder="+7 (999) 999-99-99"
            inputRef={register}
            inputStyle={styles.inputTelephone}
            dropdownStyle={styles.dropDown}
            id={name}
            specialLabel=""
            autoComplete="phone"
            country="ru"
            inputProps={{
              autoFocus: false,
              name: name,
            }}
            onChange={(value, country, e, formatedValue) => {
              setValue('phone', formatedValue);
              if (!validatePhone(value, formatedValue, country)) {
                setError(name, { message: errorMessage });
                setIsValid(false);
              } else {
                clearErrors(name);
                setIsValid(true);
              }
            }}
          />
        )}
        enableLongNumbers
        defaultValue=""
        name={name}
        control={control}
        rules={{
          required: 'Введите номер телефона',
          validate: () => isValid || errorMessage,
        }}
      />
      <Typography
        component="span"
        color="kit.text.error"
        style={styles.errorMessage}
      >
        {errors[name] && errors[name].message}
      </Typography>
    </Box>
  );
}

export default PhoneField;
